/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LessorCompanyProfileCreateModel
 */
export interface LessorCompanyProfileCreateModel {
    /**
     * 
     * @type {string}
     * @memberof LessorCompanyProfileCreateModel
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LessorCompanyProfileCreateModel
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof LessorCompanyProfileCreateModel
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LessorCompanyProfileCreateModel
     */
    title?: string | null;
}

export function LessorCompanyProfileCreateModelFromJSON(json: any): LessorCompanyProfileCreateModel {
    return LessorCompanyProfileCreateModelFromJSONTyped(json, false);
}

export function LessorCompanyProfileCreateModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): LessorCompanyProfileCreateModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'lastName': json['lastName'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'title': !exists(json, 'title') ? undefined : json['title'],
    };
}

export function LessorCompanyProfileCreateModelToJSON(value?: LessorCompanyProfileCreateModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'lastName': value.lastName,
        'email': value.email,
        'title': value.title,
    };
}

